export default function minTranslate() {
  return -this.snapGrid[0];
}


//////////////////
// WEBPACK FOOTER
// /Users/kevingroux/Desktop/Dossier Project/helvetius/web/app/themes/akyos-sage/node_modules/swiper/core/translate/minTranslate.js
// module id = 43
// module chunks = 0